// extracted by mini-css-extract-plugin
export default {"cls1":"kV6Dep8u7PRou2cMpTsv","cls2":"HlFG7Qlo0erYYmYQ5j7N kV6Dep8u7PRou2cMpTsv","isDesktopUp":"bJADfgOPrvO2U3b_EOhj","withAvatarOverlap":"avuThDZv2nLpoIPBTcQw"};